import { render, staticRenderFns } from "./SubscribeNewsletter.vue?vue&type=template&id=16695d7c&"
import script from "./SubscribeNewsletter.vue?vue&type=script&lang=js&"
export * from "./SubscribeNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports